import { motion } from "framer-motion";
import { ArrowRight, Briefcase, Crown, Heart, Sparkles } from "lucide-react";
import { IMAGES, ROLE_CARDS } from "../../data/content";
import { reveal } from "../../lib/motion";

const ICONS = { crown: Crown, sparkles: Sparkles, briefcase: Briefcase, heart: Heart };

export const RoleSelector = ({ onOpenRole }) => {
  return (
    <section
      id="seu-lugar"
      data-testid="role-selector-section"
      className="grain-overlay bg-[#141210] py-16 md:py-24 lg:py-32"
    >
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <div className="text-center">
          <motion.img
            {...reveal()}
            src={IMAGES.logo}
            alt="Emblema Ministério AURA"
            data-testid="role-selector-logo"
            className="mx-auto h-16 w-16 rounded-full object-cover drop-shadow-[0_4px_24px_rgba(197,160,89,0.5)]"
          />
          <motion.p
            {...reveal(0.1)}
            className="mt-6 text-xs font-semibold uppercase tracking-[0.3em] text-gold"
          >
            O Seu Chamado
          </motion.p>
          <motion.h2
            {...reveal(0.2)}
            className="mt-4 font-serif text-3xl text-white sm:text-4xl lg:text-5xl"
          >
            Qual é o seu lugar <em className="italic text-champagne">no AURA?</em>
          </motion.h2>
          <motion.p
            {...reveal(0.3)}
            className="mx-auto mt-4 max-w-xl text-base text-white/70 sm:text-lg"
          >
            Há um lugar reservado para você neste movimento. Escolha o seu.
          </motion.p>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4 lg:gap-8">
          {ROLE_CARDS.map((card, i) => {
            const Icon = ICONS[card.icon];
            const isApplication = card.kind === "application";
            return (
              <motion.button
                key={card.role}
                {...reveal(0.1 * (i + 1))}
                data-testid={`role-card-${card.role.toLowerCase()}`}
                onClick={() => onOpenRole(card.role)}
                className="group rounded-3xl border border-white/10 bg-white/5 p-8 text-left backdrop-blur-sm transition-all duration-300 hover:-translate-y-2 hover:border-gold/60"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gold/15">
                  <Icon className="h-5 w-5 text-gold" />
                </div>
                <h3 className="mt-6 font-serif text-2xl text-white">{card.title}</h3>
                <p className="mt-2 min-h-[60px] text-sm leading-relaxed text-white/60">
                  {card.description}
                </p>
                {isApplication ? (
                  <span className="mt-6 inline-flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-champagne transition-all duration-300 group-hover:gap-3">
                    {card.cta} <ArrowRight className="h-3.5 w-3.5" />
                  </span>
                ) : (
                  <span className="mt-6 inline-flex items-center rounded-full bg-gold/15 px-4 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-gold">
                    {card.cta}
                  </span>
                )}
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
